<template>
  <div class="flex flex-col justify-center items-center text-center gap-m bg-secondary-40  rounded-xl p-l text-white">
    <Icon
      name="iad-icon:real-estate-agent"
      class="size-10"
    />
    <IadTitle
      tag="p"
      class="text-balance"
      :text="$t('property_serp.promo.search_advisor.title')"
    />
    <IadTitle
      class="text-pretty"
      tag="span"
      variant="x-small"
      :text="$t('property_serp.promo.search_advisor.subtitle')"
    />
    <IadBtn
      :to="{
        name: `find-real-estate-agent`,
      }"
      :text="$t('core.navigation.find_agent')"
    />
  </div>
</template>
